import { Fragment, useEffect, useRef, useState } from "react";
import { RouteComponentProps } from "../../models/RouteComponent";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";

import { Grid } from "@mui/material";
import { FormControl, FormLabel } from "@mui/joy";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import { InputTextarea } from "primereact/inputtextarea";
import DropdownApi from "../../components/DropdownApi";

import S3DocumentsUpload from "../../components/S3DocumentsUpload";

import ImageS3Upload from "../../components/ImageS3Upload";
import { v4 } from "uuid";

import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { updateChemical } from "../../service/chemicalService";

import RiskAssessmentComponent from "../../components/RiskAssessmentComponent";
import ChemicalChecklistTable from "./chemical-checklist-table";
import ChemicalSiteTable from "./chemical-Site-table";

const newUuid = v4();

export default function ChemicalView(props: RouteComponentProps) {
  const chemical = props.chemical || {};

  console.log("chemical == ", chemical);

  const [name, setName] = useState(chemical.name || "");
  const [description, setDescription] = useState(chemical.description || "");
  const [chemicalType, setChemicalType] = useState(chemical.chemical_type || "");
  const [chemicalTypeObject, setChemicalTypeObject] = useState<any>({});
  const unitsTypes = [
    {
      id: "ml (Millilitres)"
    },
    {
      id: "l (Litres)"
    },
    {
      id: "g (Grams)"
    },
    {
      id: "kg (Kilograms)"
    },
    {
      id: "mg (Milligrams)"
    },
    {
      id: "µg (Micrograms)"
    },
  ]

  const [photo, setPhoto] = useState("");
  const [loading, setLoading] = useState(chemical.name || false);
  const [quantity, setQuantity] = useState(chemical.quantity || "");
  const [unit, setUnit] = useState(chemical.units || "");
  const toast = useRef(null as any);

  const session = props?.session || {};

  const clientId = session.client_id;
  const s3Key = chemical?.s3_key || `chemical/${chemical.id}`;

  async function chemicalUpdate() {
    const updateObject: any = {
      name,
      description,
      chemical_type: chemicalType,
      quantity,
      units: unit,
      s3_key: s3Key,
    };
    updateChemical(updateObject, chemical.id).then((r: any) => {
      const updatedChemical = r;
      toast.current.show({
        severity: "success",
        summary: "Chemical Updated Successfully",
        life: 3000,
      });
    });
  }

  const record_id = chemical.id || "";

  return (
    <Fragment>
      <TabView>
        <TabPanel header="Chemical Details">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <FormControl>
                  <ImageS3Upload photo={photo} setPhoto={setPhoto} s3Key={s3Key} toast={toast} />
                </FormControl>
              </Grid>
              <Grid item xs={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControl sx={{ flexGrow: 1 }}>
                      <FormLabel>
                        Name<div style={{ color: "red" }}>*</div>
                      </FormLabel>
                      <FormControl
                        sx={{
                          display: { sm: "flex-column", md: "flex-row" },
                          gap: 2,
                        }}
                      >
                        <InputText
                          value={name}
                          onChange={e => setName(e.target.value)}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                        />
                      </FormControl>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <DropdownApi
                      apiPath="chemical-type"
                      optionLabel="name"
                      optionValue="id"
                      label="Chemical Type"
                      selectedData={chemicalType}
                      setSelectedData={setChemicalType}
                      setSelectedObject={setChemicalTypeObject}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item xs={6}>
                <FormControl sx={{ flexGrow: 1 }}>
                  <FormLabel>Quantity</FormLabel>
                  <FormControl
                    sx={{
                      display: { sm: "flex-column", md: "flex-row" },
                      gap: 2,
                    }}
                  >
                    <InputText
                      value={quantity}
                      onChange={e => setQuantity(e.target.value)}
                      type="number"
                      className="p-inputtext-sm PrimeSmallInput"
                    />
                  </FormControl>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ flexGrow: 1 }}>
                  <FormLabel>Units</FormLabel>
                  <FormControl
                    sx={{
                      display: { sm: "flex-column", md: "flex-row" },
                      gap: 2,
                    }}
                  >
                    <Dropdown
                      value={unit}
                      onChange={(e: DropdownChangeEvent) => setUnit(e.value)}
                      options={unitsTypes}
                      optionLabel="id"
                      optionValue="id"
                      placeholder="Select a Unit"
                      style={{ fontSize: "small", padding: 0 }}
                      className="PrimeSmallInput custom-dropdown"
                      panelClassName="custom-dropdown-panel"
                    />
                  </FormControl>
                </FormControl>
              </Grid>
              <br />
              <Grid item xs={12}>
                <FormControl>
                  <FormLabel>Description</FormLabel>
                  <FormControl
                    sx={{
                      display: { sm: "flex-column", md: "flex-row" },
                      gap: 2,
                    }}
                  >
                    <InputTextarea
                      value={description}
                      placeholder="Description"
                      onChange={e => setDescription(e.target.value)}
                    />
                  </FormControl>
                </FormControl>
              </Grid>
              <br />
            </Grid>
          </Card>
        </TabPanel>
        <TabPanel header="Sites">
          <ChemicalSiteTable
            globalLoader={props.globalLoader}
            breadcrumbs={props.breadcrumbs}
            session={props.session}
            setBreadcrumbs={props.setBreadcrumbs}
            setGlobalLoader={props.setGlobalLoader}
            setSession={props.setSession}
            accessLevel={props.accessLevel}
            chemical={chemical}
            setAccessLevel={props.setAccessLevel}
            setEmployee={props.setEmployee}
          />
        </TabPanel>
        <TabPanel header="Checklist">
          <ChemicalChecklistTable
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            props={props}
          />
        </TabPanel>
        <TabPanel header="Documents">
          <S3DocumentsUpload
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            type="chemical"
            props={props}
          />
        </TabPanel>
        <TabPanel header="Risk">
          <RiskAssessmentComponent
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            type="Chemical"
            props={props}
          />
        </TabPanel>
      </TabView>
      <Button
        type="button"
        icon="pi pi-save"
        label="Save"
        className="p-button-outlined"
        size="small"
        style={{
          position: "absolute",
          fontSize: "small",
          right: 70,
          top: 75,
          color: "#2dd36f",
        }}
        onClick={() => chemicalUpdate()}
      />

      <Toast ref={toast} />
    </Fragment>
  );
}
